import { featureFlagsInitialized, type InitializeFeatureFlagsActionMessage, } from "owa-feature-flags";
import { orchestrator, type OrchestratorFunction } from "satcheljs";
import { initializeSigninRequiredTelemetryState } from "./signinRequiredHelpers";

export const featureFlagsInitializedOrchestrator: OrchestratorFunction<InitializeFeatureFlagsActionMessage> = orchestrator(featureFlagsInitialized, actionMessage => {
    if (!actionMessage.mailboxInfo) {
        initializeSigninRequiredTelemetryState();
    }
});
